module.exports = __webpack_public_path__ + "img/golbal_pic.c9b3f319.jpg";